import { blockInternal, requiresAuth, requiresTerms, blockEcommerce } from "@/middleware";

const CartView = () => import("./CartView.vue");

const cartRoutes = [
  {
    path: "/cart",
    name: "Cart",
    component: CartView,
    meta: {
      middleware: [requiresAuth, requiresTerms, blockInternal, blockEcommerce]
    }
  }
];

export default cartRoutes;
